import React, { useState } from "react";
import { useCart } from "react-use-cart";
import { useNavigate } from "react-router-dom";

function Checkcontent() {
  const { emptyCart, items, cartTotal } = useCart();
  const [formData, setFormData] = useState({
    country: "",
    firstName: "",
    lastName: "",
    address: "",
    state: "",
    postalZip: "",
    email: "",
    phone: "",
  });

  const [coupon, setCoupon] = useState("");
  const [couponApplied, setCouponApplied] = useState(false);
  const [couponError, setCouponError] = useState("");
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const validate = () => {
    let newErrors = {};

    if (!formData.country) newErrors.country = "Country is required.";
    if (!formData.firstName) newErrors.firstName = "First Name is required.";
    if (!formData.lastName) newErrors.lastName = "Last Name is required.";
    if (!formData.address) newErrors.address = "Address is required.";
    if (!formData.state) newErrors.state = "State/Country is required.";
    if (!formData.postalZip) newErrors.postalZip = "Postal/Zip is required.";
    if (!formData.email) {
      newErrors.email = "Email is required.";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid.";
    }
    if (!formData.phone) {
      newErrors.phone = "Phone number is required.";
    } else if (!/^\d{10,15}$/.test(formData.phone)) {
      newErrors.phone = "Phone number must be 10-15 digits.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCouponApply = () => {
    if (coupon === "DISCOUNT10") {
      setCouponApplied(true);
      setCouponError(""); 
    } else {
      setCouponApplied(false);
      setCouponError("Invalid coupon code. Please try again."); // رسالة الخطأ
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      emptyCart();
      navigate("/thank");
    }
  };

  return (
    <div className="untree_co-section">
      <div className="container">
        <div className="row">
          <div className="col-md-6 mb-5" data-aos="fade-right">
            <h2 className="h3 mb-3 text-black">Billing Details</h2>
            <form
              onSubmit={handleSubmit}
              className="p-3 p-lg-5 border bg-white"
            >
              <div className="form-group">
                <label htmlFor="country" className="text-black">
                  Country <span className="text-danger">*</span>
                </label>
                <select
                  id="country"
                  name="country"
                  className="form-control"
                  value={formData.country}
                  onChange={handleChange}
                >
                  <option value="">Select a country</option>
                  <option value="Bangladesh">Bangladesh</option>
                  <option value="Algeria">Algeria</option>
                  <option value="Afghanistan">Afghanistan</option>
                </select>
                {errors.country && (
                  <div className="text-danger">{errors.country}</div>
                )}
              </div>

              <div className="form-group row">
                <div className="col-md-6">
                  <label htmlFor="firstName" className="text-black">
                    First Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="firstName"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                  />
                  {errors.firstName && (
                    <div className="text-danger">{errors.firstName}</div>
                  )}
                </div>
                <div className="col-md-6">
                  <label htmlFor="lastName" className="text-black">
                    Last Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="lastName"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                  />
                  {errors.lastName && (
                    <div className="text-danger">{errors.lastName}</div>
                  )}
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="address" className="text-black">
                  Address <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="address"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                />
                {errors.address && (
                  <div className="text-danger">{errors.address}</div>
                )}
              </div>

              <div className="form-group row">
                <div className="col-md-6">
                  <label htmlFor="state" className="text-black">
                    State / Country <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="state"
                    name="state"
                    value={formData.state}
                    onChange={handleChange}
                  />
                  {errors.state && (
                    <div className="text-danger">{errors.state}</div>
                  )}
                </div>
                <div className="col-md-6">
                  <label htmlFor="postalZip" className="text-black">
                    Postal / Zip <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="postalZip"
                    name="postalZip"
                    value={formData.postalZip}
                    onChange={handleChange}
                  />
                  {errors.postalZip && (
                    <div className="text-danger">{errors.postalZip}</div>
                  )}
                </div>
              </div>

              <div className="form-group row mb-5">
                <div className="col-md-6">
                  <label htmlFor="email" className="text-black">
                    Email Address <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                  {errors.email && (
                    <div className="text-danger">{errors.email}</div>
                  )}
                </div>
                <div className="col-md-6">
                  <label htmlFor="phone" className="text-black">
                    Phone <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                  {errors.phone && (
                    <div className="text-danger">{errors.phone}</div>
                  )}
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="c_code" className="text-black mb-3">
                  Coupon Code
                </label>
                <div className="input-group w-75 couponcode-wrap">
                  <input
                    type="text"
                    className="form-control me-2"
                    id="c_code"
                    placeholder="Coupon Code"
                    value={coupon}
                    onChange={(e) => setCoupon(e.target.value)}
                  />
                  <div className="input-group-append">
                    <button
                      className="btn btn-black btn-sm"
                      type="button"
                      onClick={handleCouponApply}
                    >
                      Apply
                    </button>
                  </div>
                </div>
                {couponError && (
                  <div className="text-danger mt-2">{couponError}</div>
                )}
                {couponApplied && (
                  <div className="text-success mt-2">
                    Coupon applied successfully!
                  </div>
                )}
              </div>

              <button
                type="submit"
                className=" mt-4 btn btn-black btn-lg py-3 btn-block"
              >
                Place Order
              </button>
            </form>
          </div>

          <OrderSummary items={items} cartTotal={cartTotal} />
        </div>
      </div>
    </div>
  );
}

function OrderSummary({ items, cartTotal }) {
  return (
    <div className="col-md-6" data-aos="fade-left">
      <h2 className="h3 mb-3 text-black">Your Order</h2>
      <div className="p-3 p-lg-5 border bg-white">
        <table className="table site-block-order-table mb-5">
          <thead>
            <tr>
              <th>Product</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={index}>
                <td>
                  {item.title} <strong className="mx-2">x</strong>{" "}
                  {item.quantity}
                </td>
                <td>${Math.round(item.price * item.quantity)}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td>
                <b>Total</b>:
              </td>
              <td>${Math.round(cartTotal)}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
}

export default Checkcontent;
